<template>

   <div class="w_inner">
      <div class="con_box inner_banner news wow fadeIn animated" data-wow-delay="0.0s">
         </div>
         <div class="innerWrap">
             <div class="newsloc">
                <div class="con w">
                    <span>{{$t('news.title')}}</span>
                    <span class="ico">&gt;</span>
                    <span>{{$t('news.detail')}}</span>
                </div>
             </div>
             <div class="main_container w">
                 <div class="newsDesc">
                     <div class="tiBarShow">{{dto.title}}</div>
                     <div class="article_meta">
                         <span>{{$t('news.source')}}：{{dto.source}}</span>
                         <span>{{$t('news.date')}}：{{dto.publishTime}}</span>
                     </div>
                     <div class="article_content" v-html="dto.content">
                     </div>
                 </div>
             </div>
         </div>
   </div>

</template>

<script>
import WOW from "../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      id:this.$route.params.id,
      dto:{}
    }
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    document.documentElement.scrollTop = 0;
  },

  created: function () {
    this.GetDetail();
  },
  components: {
    
  },
  methods: {
    
        
        Initwow(){
              let wow = new WOW.WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true
            });
             wow.init();
        },
        GetDetail() {
            var url = "/pageapi/News/GetDetail";
            this.$http.post(url,{id:this.id}).then(function(res){
                if (res.data.status==1){
                   this.dto = res.data.ds;
                }
            }.bind(this)).catch(function(){
            });
        },
  },
   watch: {
     $route(newVal,oldVal){
        this.id=this.$route.params.id;
        this.GetCat();
        this.GetProList();
     }
  }
};
</script>
